// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1249":"4a17dc96be30e4c4","6698":"7792890bbfe1711d"}[chunkId] + ".js";
};